/* eslint-disable no-shadow */
/* eslint-disable react/require-default-props */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
/* eslint-disable no-console */
import React, { createContext, useCallback, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import getApi, { getApiFromStorage, type SiteType } from "../services/api";

export interface UserInterface {
  id: number;
  name: string;
  username: string;
  full_name: string;
  email: string;
  cpf: string;
}

interface AuthState {
  token: string;
  user: UserInterface | any;
  migrated_user?: boolean;
}

interface SignInCredentials {
  user: string;
  password: string;
  siteType: SiteType;
}

interface AuthContextData {
  user: UserInterface | any;
  signIn(credentials: SignInCredentials): Promise<void>;
  signOut(): void;
  setData?(e: any): void;
  data: any;
}

interface ChildrenProps {
  children?: any;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

const AuthProvider: React.FC<ChildrenProps> = ({ children }) => {
  const [data, setData] = useState<AuthState>(() => {
    const token = localStorage.getItem("@Admin:token");
    const user = localStorage.getItem("@Admin:user");
    const siteType = localStorage.getItem("@Admin:siteType");
    if (siteType === "PJ") {
      if (token) {
        const api = getApiFromStorage();
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
        return { token, user: "Admin" };
      }
    } else {
      if (token && user) {
        const api = getApiFromStorage();
        api.defaults.headers.common.Authorization = `Bearer ${token}`;
        return { token, user: JSON.parse(user) };
      }
      return {} as AuthState;
    }
  });

  const { push } = useHistory();

  const signIn = useCallback(
    async ({
      user,
      password,
      siteType,
    }: SignInCredentials & { siteType: SiteType }) => {
      const api = getApi(siteType);
      if (siteType === "PF") {
        const response = await api.post("/accounts/login-superuser/", {
          user,
          password,
        });
        const { token, user: userData } = response.data;

        // salva o tipo escolhido no storage
        localStorage.setItem("@Admin:token", token);
        localStorage.setItem("@Admin:user", JSON.stringify(userData));
        localStorage.setItem(
          "@UserGroup:group",
          JSON.stringify(response.data.user?.groups)
        );
        localStorage.setItem("@Admin:siteType", siteType);

        api.defaults.headers.common.Authorization = `Bearer ${token}`;

        setData({ token, user: userData });
      } else {
        const response = await api.post("v1/accounts/token/", {
          user,
          password,
        });
        console.log(response);

        const { access, refresh } = response.data;
        console.log(response?.data);

        localStorage.setItem("@Admin:token", access);
        localStorage.setItem("@Admin:user", "Admin");
        localStorage.setItem("@Admin:siteType", siteType);

        api.defaults.headers.common.Authorization = `Bearer ${access}`;

        setData({ token: access, user: "Admin" });
      }
    },
    []
  );

  const signOut = useCallback(async () => {
    try {
      const api = getApiFromStorage();
      await api.get("/accounts/logout/");
    } catch (error) {
      console.log("error", error);
    } finally {
      localStorage.removeItem("@Admin:token");
      localStorage.removeItem("@Admin:user");
      localStorage.removeItem("@Admin:siteType");
      localStorage.removeItem("@UserGroup:group");

      setData({} as AuthState);
      push("/login");
    }
  }, [push]);
  // React.useEffect(() => {
  //   const token = localStorage.getItem('@Transfacil:token');
  //   const user = localStorage.getItem('@Transfacil:user');

  //   if (!token || !user) {
  //     return () => {
  //       delete api.defaults.headers.Authorization;
  //     };
  //   }
  // }, [data.token]);

  return (
    <>
      <AuthContext.Provider
        value={{ user: data.user, data, setData, signIn, signOut }}
      >
        {children}
      </AuthContext.Provider>
    </>
  );
};

function useAuth(): AuthContextData {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth só pode ser usado dentro de um AuthProvider");
  }

  return context;
}

export { AuthProvider, useAuth };
